import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';

import { CloudSharedLibComponent } from './cloud-shared-lib.component';
import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { PipesModule } from './pipes/pipes.module';
import { CuttingButtFormService } from './services/cutting-butt-form.service';
import { PanelsSchemaService } from './services/panels-schema.service';

@NgModule({
  imports: [
    ComponentsModule,

    MatIconModule, //
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    CdkTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatMenuModule,
    MatDialogModule,
    MatSortModule,
    MatRippleModule,
    MatDividerModule,
    MatToolbarModule,
    MatCardModule,
    MatBottomSheetModule,
    DirectivesModule,
    PipesModule,
  ],
  declarations: [
    CloudSharedLibComponent, //
  ],
  exports: [
    CloudSharedLibComponent, //
    DirectivesModule,
    ComponentsModule,
    PipesModule,
  ],
  providers: [
    CuttingButtFormService, //
    PanelsSchemaService,
  ],
})
export class CloudSharedLibModule {}
